import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const Terms = () => {
  return (
    <>
      <SEO 
        title="Terms of Service - ViralVoice AI"
        description="Terms of Service and usage guidelines for ViralVoice AI"
      />
      <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white py-20">
        {/* Back to Home */}
        <Link 
          to="/" 
          className="fixed top-6 left-6 flex items-center gap-2 px-4 py-2 text-gray-400 hover:text-white transition-colors z-10"
        >
          <svg 
            className="w-5 h-5" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M10 19l-7-7m0 0l7-7m-7 7h18" 
            />
          </svg>
          Back to Home
        </Link>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
            Terms of Service
          </h1>
          
          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Agreement to Terms</h2>
              <p>Last updated: {new Date().toLocaleDateString()}</p>
              <p className="mt-4">
                By accessing or using ViralVoice AI, you agree to be bound by these Terms of Service and all applicable laws and regulations.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Use License</h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>Beta access is subject to availability</li>
                <li>Account usage is limited to one user</li>
                <li>Proper usage of AI-generated content</li>
                <li>Compliance with platform guidelines</li>
                <li>Responsible use of voice cloning technology</li>
              </ul>
            </section>

            {/* Add more sections as needed */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms; 